import * as React from "react";
import { useState, useEffect } from "react";
import { Mail, MessageSquare } from "react-feather";
import WhatsappIcon from "./WhatsappIcon";

interface Props {
  actions: string[];
  actionLead: (action: string) => any;
  message: string;
}

const ShowActions: React.FC<Props> = ({ actionLead, actions, message }) => {
  const renderActions = () => {
    return actions.map((v) => {
      switch (v) {
        case "mail":
          return (
            <div className="col-4" key={v}>
              <Mail onClick={() => actionLead(v)} />
            </div>
          );
        case "sms":
          return (
            <div className="col-4" key={v} >
                <MessageSquare onClick={() => actionLead(v)} />
            </div>
          );

        case "wp":
          return (
            <div className="col-4" key={v}>
             <i onClick={() => actionLead(v)}> <WhatsappIcon/></i>
            </div>
          );
      }
    });
  };
  return (
    <div
      className="row w-100 position-absolute d-flex align-items-end"
      style={{
        backgroundColor: "rgba(0,0,0,0.5)",
        zIndex: 5,
        height: "100vh",
      }}
    >
      <div
        className="card w-100"
        style={{ height: "30vh", borderRadius: ".25rem .25rem 0px 0px" }}
      >
        <div className="card-header">
          <h4>¿Te interesa?</h4>
        </div>
        <div className="card-body">
          <div className="row text-center ">
            {renderActions()}
          </div>
          {
            message && (
            <div className="row text-center justify-content-center h-100 align-content-end">
              <div className="m-2 p-1" style={{backgroundColor: "rgba(0,0,0, 0.2)", borderRadius: "5px"}}>
                <p style={{color: "#fff", marginBottom: "0px"}}>
                  {message}
                </p>
              </div>
            </div>
            )
          }
        </div>
      </div>
    </div>
  );
};

export default ShowActions;
